import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "../DiffusionOptionsDesc/DiffusionOptionsDesc.css";

import GuidanceInputImage from "../../../image/for-style-change/for-about/sch-input-manwoman-h125.jpg"
import GuidanceMaskImage from "../../../image/for-style-change/for-about/sch-mask-manwoman-1-h100.jpeg"
import GuidanceStyleImage from "../../../image/for-style-change/for-about/sch-style-starry-crop-h100.jpeg";
import GuidanceOutputImage1 from "../../../image/for-style-change/option-description/guidance/manwoman-output-starry-g2-125.jpeg";
import GuidanceOutputImage2 from "../../../image/for-style-change/option-description/guidance/manwoman-output-starry-g6-h125.jpeg";

function StyleChangeDescGuidance() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('syleChangeOptions19', 'When higher value is used more styles are transfered. When lower value is used less styles are transfered.')}
          <br/>
          6
          {' '}
          {t('syleChangeOptions18', 'is good starting point for image generation.')}
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={GuidanceInputImage}
              />
              {t('aboutPage.13', 'Input image')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={GuidanceMaskImage}
              />
              {t('aboutStyleChange05', 'Selected part')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={GuidanceStyleImage}
              />
               {t('aboutStyleChange06', 'Style image')}
            </div>
          </div>
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">

            <div>
              <img className="diffsionOptionDescImage"
                src={GuidanceOutputImage1}
              />
              2
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={GuidanceOutputImage2}
              />
              6
            </div>
          </div>
        </div>
      </div>
    )
  }


export default StyleChangeDescGuidance